import React from 'react';
import styles from '../agentlistitem/AgentListItem.less';
import { getBadge } from '../../utils/badgeUtils';
export var AgentBadge = function AgentBadge(_ref) {
  var badges = _ref.badges;
  var badge = getBadge(badges);
  if (!badge) {
    return null;
  }
  return /*#__PURE__*/React.createElement("img", {
    loading: "lazy",
    alt: badge.type,
    src: badge.url,
    className: styles.badge,
    "data-testid": "agent-badge"
  });
};